// Phase 40 Plan 02 — surfaces ?auth_error=… from AuthCallback as a dismissible
// banner. Reads the URL query string on mount, removes the param after rendering
// so a refresh doesn't re-show it. Self-mounts via App.jsx — no parent state
// needed.

import React, { useState, useEffect } from 'react';
import { AlertCircle, X } from 'lucide-react';

export default function AuthErrorBanner() {
  const [error, setError] = useState(() => {
    if (typeof window === 'undefined') return null;
    try {
      const url = new URL(window.location.href);
      return url.searchParams.get('auth_error');
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (!error) return;
    // Strip the query param so refresh doesn't re-show.
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('auth_error');
      window.history.replaceState({}, '', url.toString());
    } catch {}
    // Auto-dismiss after 8 seconds.
    const t = setTimeout(() => setError(null), 8000);
    return () => clearTimeout(t);
  }, [error]);

  if (!error) return null;

  return (
    <div
      role="alert"
      style={{
        position: 'fixed', left: 16, right: 16, bottom: 80, zIndex: 3000,
        maxWidth: 480, margin: '0 auto',
        background: 'var(--c-danger-bg)', color: 'var(--c-danger)',
        border: '1px solid var(--c-danger-border)', borderRadius: 12,
        padding: '12px 14px', display: 'flex', gap: 10, alignItems: 'flex-start',
        boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
        fontFamily: 'Lora, serif', fontSize: '0.875rem', lineHeight: 1.45,
      }}
    >
      <AlertCircle size={18} style={{ flexShrink: 0, marginTop: 2 }} aria-hidden="true" />
      <div style={{ flex: 1, minWidth: 0 }}>
        <strong style={{ display: 'block', marginBottom: 2 }}>Sign-in failed</strong>
        <span style={{ wordBreak: 'break-word' }}>{error}</span>
      </div>
      <button
        type="button"
        onClick={() => setError(null)}
        aria-label="Dismiss sign-in error"
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          color: 'var(--c-danger)', padding: 4, flexShrink: 0,
        }}
      >
        <X size={16} aria-hidden="true" />
      </button>
    </div>
  );
}
